import _ from "lodash";
window._ = _;

import L from "leaflet";
window.L = L;

import moment from "moment";
window.moment = moment;

import qq from "../../../node_modules/fine-uploader/lib/jquery/s3";
window.qq = qq;

import numeral from "numeral";
window.numeral = numeral;

import "jquery.nicescroll/dist/jquery.nicescroll.min";
import "../../../node_modules/jquery-ui-touch-punch/jquery.ui.touch-punch";
import "../../../node_modules/leaflet-areaselect/src/leaflet-areaselect";
import "leaflet-draw";

import "redactor";
import "redactor/plugins/fontcolor";
import "redactor/plugins/fontsize";
import "redactor/plugins/fullscreen";

import "angular";
import "../../../node_modules/angular-promise-tracker/promise-tracker";
import "angular-spectrum-colorpicker";
import "../../../node_modules/checklist-model/checklist-model";
import "angular-animate";
import "angular-sanitize";
import "../../../node_modules/ngGeolocation/ngGeolocation";
import "ngprogress-lite";
import "restangular";
import "angular-bootstrap";
import "angular-ui-router";
import "../../../node_modules/angular-ui-utils/ui-utils";
import "../../../node_modules/angular-xeditable/dist/js/xeditable";
import "angular-ui-sortable";
import { AngularTruTerritorySide } from "../../../src/pages/TruTerritory/Side/TruTerritorySide";
import { AngularEpiMap } from "../../../src/pages/TruTerritory/Map";

/*
|--------------------------------------------------------------------------
| Public Maps
|--------------------------------------------------------------------------
*/

angular
  .module("app", [
    "ajoslin.promise-tracker",
    "ngAnimate",
    "ngGeolocation",
    "ui.router",
    "ui.bootstrap",
    "ui.utils",
    "restangular",

    require("../../views").default,

    // Load the app-wide configuration
    require("../../configuration/setup").default,
    require("../../configuration/http").default,
    require("../../configuration/other").default,
    require("../../configuration/restangular").default,
    require("../../configuration/storage").default,

    // Bootstrap the app
    require("../../bootstrap/http").default,

    // All the Epiphany specific stuff
    require("./routes/views/index").default,
    require("./routes/index").default,

    require("../../common/modules/index").default,
    require("../../common/modules/mapping/index").default,
    require("../../common/modules/admin/index").default,
    require("../../common").default,

    require("./bootstrap/routes.mapping").default,
  ])
  .component("epiTruterritorySide", AngularTruTerritorySide)
  .component("epiMapV2", AngularEpiMap);
